import * as React from 'react';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { Icon } from 'ui/common/icon';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { ComponentProps } from 'ui/common';
import { ChildEntityCountShape } from 'app/area/case/selectors';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { isCaseViewModalOpen } from 'app/components/helpers';

interface FactItemAssesmentrops extends ComponentProps, FactItemProps {
  numberOfAssessments: ChildEntityCountShape;
}

export const AssessmentFactItem = (props: FactItemAssesmentrops) => {
  const { tooltip, title, numberOfAssessments, url, linkDomain, portalTarget } = props;
  const iconAbsolutePath = toAbsoluteUrl('i/Assessment.svg');
  const iconAssessments = <Icon url={iconAbsolutePath} />;
  const items = [
    { value: numberOfAssessments?.count as number, tooltip }
  ];  

  if (!numberOfAssessments?.count) {
    return null;
  }
  
  return <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url} skipNavigation={isCaseViewModalOpen()}>
    <BadgeList
      icon={iconAssessments}
      title={title}
      valueItems={items}
      portalTarget={portalTarget}
    />
  </FactLink>;
};
